// 教育平台路由
export default [
  // 首页路由重定向
  {
    path: "/",
    redirect: "home"
  },
  // 首页
  {
    path: "/home",
    name: "home",
    component: () => import("@/pages/home/index")
  },
  // 论坛列表
  {
    path: "/forum",
    name: "forum",
    redirect: "/forum/list",
    component: () => import("@/pages/forum/index"),
    meta: {
      name: "forum"
    },
    children: [
      {
        path: "/forum/list",
        name: "forumList",
        component: () => import("@/pages/forum/list"),
        meta: {
          name: "forum"
        }
      },
      {
        path: "/forum/createForum",
        name: "createForum",
        component: () => import("@/pages/forum/createForum"),
        meta: {
          name: "forum"
        }
      }
    ]
  },
  // 直播课程
  {
    path: "/moreLive",
    name: "moreLive",
    component: () => import("@/pages/moreLive/index"),
    meta: {
      name: "moreLive"
    }
  },
  // 视频课程
  {
    path: "/course",
    name: "course",
    component: () => import("@/pages/course/index"),
    meta: {
      name: "course"
    }
  },
  // 视频课程详情
  {
    path: "/courseDetail",
    name: "courseDetail",
    component: () => import("@/pages/courseDetail/index"),
    meta: {
      name: "courseDetail"
    }
  },
  // 更多学习概况
  {
    path: "/moreStudy",
    name: "moreStudy",
    component: () => import("@/pages/moreStudy/index"),
    meta: {
      name: "moreStudy"
    }
  },
  // 直播回放
  {
    path: "/replayLive",
    name: "replayLive",
    component: () => import("@/pages/replayLive/index"),
    meta: {
      name: "replayLive"
    }
  },
  // 视频学习
  {
    path: "/videoPlay",
    name: "videoPlay",
    component: () => import("@/pages/videoPlay/index"),
    meta: {
      name: "videoPlay"
    }
  },
  {
    path: "/videoPlayThird",
    name: "videoPlayThird",
    component: () => import("@/pages/videoPlayThird/index"),
    meta: {
      title: "视频播放"
    }
  },
  // 随堂练习
  {
    path: "/doWork",
    name: "doWork",
    component: () => import("@/pages/doWork/index"),
    meta: {
      name: "doWork"
    }
  },
  // 随堂练习详情
  {
    path: "/answerResult",
    name: "answerResult",
    component: () => import("@/pages/answerResult/index"),
    meta: {
      name: "answerResult"
    }
  },
  // 答案解析
  {
    path: "/readAnswer",
    name: "readAnswer",
    component: () => import("@/pages/readAnswer/index"),
    meta: {
      name: "readAnswer"
    }
  },
  // 错题集
  {
    path: "/readWrongAnswer",
    name: "readWrongAnswer",
    component: () => import("@/pages/readWrongAnswer/index"),
    meta: {
      name: "readWrongAnswer"
    }
  },
  {
    path: "/degree",
    name: "degree",
    component: () => import("@/pages/degree/index"),
    meta: {
      name: "degree"
    }
  },
  {
    path: "/degreeInfo",
    name: "degreeInfo",
    component: () => import("@/pages/degreeInfo/index"),
    meta: {
      name: "degreeInfo"
    }
  },
  {
    path: "/simulatePracticeDetail",
    name: "simulatePracticeDetail",
    component: () => import("@/pages/simulatePracticeDetail/index"),
    meta: {
      name: "simulatePracticeDetail"
    }
  },
  {
    path: "/simulatePracticeResult",
    name: "simulatePracticeResult",
    component: () => import("@/pages/simulatePracticeResult/index"),
    meta: {
      name: "simulatePracticeResult"
    }
  },
  {
    path: "/aiChat",
    name: "aiChat",
    component: () => import("@/pages/aiChat/index"),
    meta: {
      name: "aiChat"
    }
  },
  // 直播页面
  {
    path: "/livePage",
    name: "livePage",
    component: () => import("@/pages/livePage/index"),
    meta: {
      name: "livePage"
    }
  },
  // 文档学习
  {
    path: "/readDoc",
    name: "readDoc",
    component: () => import("@/pages/readDoc/index"),
    meta: {
      name: "readDoc"
    }
  },
  // 作业
  {
    path: "/homeWork",
    name: "homeWork",
    component: () => import("@/pages/homeWork/index"),
    meta: {
      name: "homeWork"
    }
  },
  // 我的学籍
  {
    path: "/myRoll",
    name: "myRoll",
    component: () => import("@/pages/myRoll/index"),
    meta: {
      name: "myRoll"
    }
  },
  // 我的成绩
  {
    path: "/myGrade",
    name: "myGrade",
    component: () => import("@/pages/myGrade/index"),
    meta: {
      name: "myGrade"
    }
  },
  // 我的提问
  {
    path: "/myAsk",
    name: "myAsk",
    component: () => import("@/pages/myAsk/index"),
    meta: {
      name: "myAsk"
    }
  },
  // 直播回放
  {
    path: "/playBack",
    name: "playBack",
    component: () => import("@/pages/playBack/index"),
    meta: {
      name: "playBack"
    }
  },
  // 我的考勤
  {
    path: "/myAttendance",
    name: "myAttendance",
    component: () => import("@/pages/myAttendance/index"),
    meta: {
      name: "myAttendance"
    }
  },
  // 缴费记录
  {
    path: "/feeDetail",
    name: "feeDetail",
    component: () => import("@/pages/feeDetail/index"),
    meta: {
      name: "feeDetail"
    }
  },
  // 学习记录
  {
    path: "/myStudy",
    name: "myStudy",
    component: () => import("@/pages/myStudy/index"),
    meta: {
      name: "myStudy"
    }
  },
  // 我的课表
  {
    path: "/myCourseForm",
    name: "myCourseForm",
    component: () => import("@/pages/myCourseForm/index"),
    meta: {
      name: "myCourseForm"
    }
  },
  // 我的论坛
  {
    path: "/myForum",
    name: "myForum",
    component: () => import("@/pages/forum/myForum"),
    meta: {
      name: "myForum"
    }
  },
  {
    path: "/moreThesisSupervision",
    name: "moreThesisSupervision",
    component: () => import("@/pages/moreThesisSupervision/index"),
    meta: {
      title: "论文指导"
    }
  },
  {
    path: "/playThesis",
    name: "playThesis",
    component: () => import("@/pages/playThesis/index"),
    meta: {
      title: "论文指导"
    }
  },
  {
    path: "/thesis",
    name: "thesis",
    component: () => import("@/pages/thesis/index"),
    meta: {
      name: "thesis"
    }
  },
  {
    path: "/thesisList",
    name: "thesisList",
    component: () => import("@/pages/thesisList/index"),
    meta: {
      name: "thesisList"
    }
  },
  {
    path: "/thesisInfo",
    name: "thesisInfo",
    component: () => import("@/pages/thesisInfo/index"),
    meta: {
      name: "thesisInfo"
    }
  },
  // 我的申诉
  {
    path: "/myAppeal",
    name: "myAppeal",
    component: () => import("@/pages/myAppeal/index"),
    meta: {
      name: "myAppeal"
    }
  },
  // 在线考试
  {
    path: "/onlineExamination",
    name: "onlineExamination",
    component: () => import("@/pages/onlineExamination/index"),
    meta: {
      name: "onlineExamination"
    }
  },
  // 学籍卡
  {
    path: "/rollCard",
    name: "rollCard",
    component: () => import("@/pages/rollCard/index"),
    meta: {
      name: "rollCard"
    }
  },
  // 考试答题
  {
    path: "/onlineExaming",
    name: "onlineExaming",
    component: () => import("@/pages/onlineExaming/index"),
    meta: {
      name: "onlineExamination"
    }
  },
  // 答题情况
  {
    path: "/onlineExamInfo",
    name: "onlineExamInfo",
    component: () => import("@/pages/onlineExamInfo/index"),
    meta: {
      name: "onlineExamination"
    }
  },
  // 考试记录
  {
    path: "/onlineExamRecord",
    name: "onlineExamRecord",
    component: () => import("@/pages/onlineExamRecord/index"),
    meta: {
      name: "onlineExamination"
    }
  },
  // 教学质量评价
  {
    path: "/teachEvaluate",
    name: "teachEvaluate",
    component: () => import("@/pages/teachEvaluate/index"),
    meta: {
      name: "teachEvaluate"
    }
  },
  {
    path: "/teachEvaluateInfo",
    name: "teachEvaluateInfo",
    component: () => import("@/pages/teachEvaluateInfo/index"),
    meta: {
      name: "teachEvaluate"
    }
  },
  {
    path: "/teachEvaluateNetInfo",
    name: "teachEvaluateNetInfo",
    component: () => import("@/pages/teachEvaluateNetInfo/index"),
    meta: {
      name: "teachEvaluate"
    }
  },
  // 我的收件箱
  {
    path: "/myMsg",
    name: "myMsg",
    component: () => import("@/pages/myMsg/index"),
    meta: {
      name: "myMsg"
    }
  },
  // 教学计划课程
  {
    path: "/myPlanCourse",
    name: "myPlanCourse",
    component: () => import("@/pages/myPlanCourse/index"),
    meta: {
      name: "myPlanCourse"
    }
  },
  // 意见反馈
  {
    path: "/myFeedback",
    name: "myFeedback",
    component: () => import("@/pages/myFeedback/index"),
    meta: {
      name: "myFeedback"
    }
  },
  // 暂缓注册
  {
    path: "/rollRegister",
    name: "rollRegister",
    component: () => import("@/pages/rollRegister/index"),
    meta: {
      name: "rollRegister"
    }
  },
  // 暂缓毕业
  {
    path: "/slowGraduation",
    name: "slowGraduation",
    component: () => import("@/pages/slowGraduation/index"),
    meta: {
      name: "slowGraduation"
    }
  },
  // 学生报到
  {
    path: "/checkIn",
    name: "checkIn",
    component: () => import("@/pages/checkIn/index"),
    meta: {
      name: "checkIn"
    }
  },
  // 学籍异动
  {
    path: "/rollChange",
    name: "rollChange",
    component: () => import("@/pages/rollChange/index"),
    meta: {
      name: "rollChange"
    }
  },
  // 常见问题
  {
    path: "/question",
    name: "question",
    component: () => import("@/pages/question/index"),
    meta: {
      name: "question"
    }
  },
  // 网站公告列表
  {
    path: "/notice",
    name: "notice",
    component: () => import("@/pages/notice/index")
  },
  // 账号管理
  {
    path: "/account",
    name: "account",
    component: () => import("@/pages/account/index"),
    meta: {
      name: "account"
    }
  },
  // 联系我们
  {
    path: "/contactUs",
    name: "contactUs",
    component: () => import("@/pages/contactUs/index"),
    meta: {
      name: "contactUs"
    }
  },
  // 电子签名预览
  {
    path: "/signaturePreview",
    name: "signaturePreview",
    component: () => import("@/pages/signaturePreview/index"),
    meta: {
      name: "signaturePreview"
    }
  },
  // 毕业登记
  {
    path: "/graduateRegister",
    name: "graduateRegister",
    component: () => import("@/pages/graduateRegister/index"),
    meta: {
      name: "graduateRegister"
    }
  },
  // 资料下载
  {
    path: "/downLoadData",
    name: "downLoadData",
    component: () => import("@/pages/downLoadData/index"),
    meta: {
      name: "downLoadData"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/education.js